export const CHILD_DEFAULT_AGE = "8";
